import { memo } from "react";
import { Flex } from "../../../flex";
import { Text } from "../../../text";
import * as legendCss from "./legend.module.css";
import { ChartSeries, RedoChartLegendPosition } from "./types";

export const ChartLegendItem = memo(function ChartLegendItem({
  name,
  color,
}: {
  name: string;
  color: string;
}) {
  return (
    <Flex align="center" gap="xs">
      <div
        className={legendCss.legendIndicator}
        style={{ backgroundColor: color }}
      />
      <Text fontSize="sm" textColor="tertiary" title={name}>
        {name}
      </Text>
    </Flex>
  );
});

export const ChartLegend = memo(function ChartLegend({
  series,
  position,
}: {
  series: ChartSeries[];
  position: RedoChartLegendPosition;
}) {
  if (!position || !series.length) {
    return null;
  }

  return (
    <Flex
      className={position === "right" ? legendCss.legendRight : ""}
      flexDirection={
        position === "top" || position === "bottom" ? "row" : "column"
      }
      gap="md"
      justify={position === "bottom" ? "center" : "flex-start"}
      wrap={position === "top" || position === "bottom" ? "wrap" : "nowrap"}
    >
      {series.map((item, index) => (
        <ChartLegendItem
          color={item.color || ""}
          key={index}
          name={item.name}
        />
      ))}
    </Flex>
  );
});
